module.exports = {"name":"doclite","version":"0.0.0","description":"Minimalist documentation generator","keywords":["documentation","docs","literate","generator"],"homepage":"https://r24y.github.io/doclite","main":"index.js","files":["index.js"],"dependencies":{"babel-traverse":"6.26.0","babel-types":"6.26.0","babylon":"6.18.0"},"scripts":{"postinstall":"(cd docs && npm install)","start":"(cd docs && npm start)","build":"(cd docs && npm run build)","predeploy":"npm run build","deploy":"gh-pages -d docs/build"},"devDependencies":{"gh-pages":"^1.1.0"}}


//////////////////
// WEBPACK FOOTER
// ../package.json
// module id = 361
// module chunks = 0